import { SocketContext } from '@context/socket';
import { useContext } from 'react';

export default function useSocket() {
    const socket = useContext(SocketContext);
    return socket;
}
